<template>
  <div class="table-wrapper-scroll-y">
    <b-table :items="partials" :fields="fields">
      <template slot="workOrderDate" slot-scope="data">{{data.item.workOrderDate | moment('DD/MM/YYYY')}}</template>
    </b-table>
  </div>
</template>

<script>

import { yesOrNo, formatDecimal, translateMealCost, translateType, translateStatus } from '@/formatters'

export default {
  name: 'ProjectOthersPartialsTable',
  props: {
    partials: {type: Array, required: true}
  },
  created() {
    this.fields = [
      // {key: 'id', label: 'Parte', sortable: true, thStyle: {width: '80px'}, tdAttr: {width: '80px'}},
      // {
      //   key: 'workOrderType',
      //   label: 'Tipo',
      //   sortable: true,
      //   formatter: translateType,
      //   thStyle: {width: '100px'},
      //   tdAttr: {width: '100px'}
      // },
      // {key: 'validationStatus', label: 'Estado', sortable: true, formatter: translateStatus},
      // {key: 'employeeName', label: 'Operario', sortable: true},
      // {
      //   key: 'preventiveResource',
      //   label: 'Recurso',
      //   class: 'text-center',
      //   thStyle: {width: '80px'},
      //   tdAttr: {width: '80px'},
      //   formatter: yesOrNo
      // },
      // {key: 'ordinaryHours', label: 'Horas', class: 'text-center', thStyle: {width: '80px'}, tdAttr: {width: '80px'}, formatter: formatDecimal},
      // {key: 'overtimeHours', label: 'Extra', class: 'text-center', thStyle: {width: '80px'}, tdAttr: {width: '80px'}, formatter: formatDecimal},
      // {
      //   key: 'mealCostType',
      //   label: 'Dietas',
      //   thStyle: {width: '50px'},
      //   tdAttr: {width: '50px'},
      //   formatter: translateMealCost
      // },
      // {key: 'travelKm', label: 'Km', class: 'text-center', thStyle: {width: '80px'}, tdAttr: {width: '80px'}},
      // { key: 'shiftWork', label: 'Turnicidad', class: 'text-center', formatter: yesOrNo },
      // { key: 'nightShift', label: 'Nocturnidad', class: 'text-center', formatter: yesOrNo },
      // {key: 'holidayHours', label: 'Festivas', class: 'text-center', thStyle: {width: '80px'}, tdAttr: {width: '80px'}, formatter: formatDecimal},
      // { key: 'pauseHours', label: 'Pausa', class: 'text-center', formatter: formatDecimal },
      // { key: 'onCallDuty', label: 'Guardia', class: 'text-center', formatter: yesOrNo },
      // { key: 'saturday', label: 'Sábado', class: 'text-center', formatter: yesOrNo },
      // { key: 'holiday', label: 'Domingo/Festivo', class: 'text-center', formatter: yesOrNo }

      {key: 'id', label: 'Parte', sortable: true, thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
      {
        key: 'workOrderType',
        label: 'Tipo',
        sortable: true,
        formatter: translateType,
        thStyle: {width: '100px'},
        tdAttr: {width: '100px'}
      },
      {key: 'validationStatus', label: 'Estado', sortable: true, formatter: translateStatus},
      {key: 'workOrderDate', label: 'Fecha', sortable: true},
      {key: 'employeeName', label: 'Operario', sortable: true},
      {key: 'projectTitle', label: 'Proyecto', sortable: true, formatter: (v, k, item) => item.projectCodeId + ' - ' + v},
      {key: 'project.client.name', label: 'Cliente', sortable: true, formatter: (v, k, item) => item.clientName},
      {
        key: 'preventiveResource',
        label: 'Recurso',
        class: 'text-center',
        thStyle: {width: '60px'},
        tdAttr: {width: '60px'},
        formatter: yesOrNo
      },
      {key: 'ordinaryHours', label: 'Horas', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
      {key: 'overtimeHours', label: 'Extra', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
      {key: 'holidayHours', label: 'Festivas', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
      {key: 'pauseHours', label: 'Pausa', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
      {
        key: 'mealCostType',
        label: 'Dietas',
        thStyle: {width: '50px'},
        tdAttr: {width: '50px'},
        formatter: v => translateMealCost(v)
      },
      {key: 'travelKm', label: 'Km', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
      {
        key: 'shiftWork',
        label: 'Turnicidad',
        class: 'text-center',
        thStyle: {width: '75px'},
        tdAttr: {width: '75px'},
        formatter: yesOrNo
      },
      {
        key: 'nightShift',
        label: 'Nocturnidad',
        class: 'text-center',
        thStyle: {width: '90px'},
        tdAttr: {width: '90px'},
        formatter: yesOrNo
      },
      {
        key: 'onCallDuty',
        label: 'Guardia',
        class: 'text-center',
        thStyle: {width: '60px'},
        tdAttr: {width: '60px'},
        formatter: yesOrNo
      },
      {
        key: 'saturday',
        label: 'Sábado',
        class: 'text-center',
        thStyle: {width: '60px'},
        tdAttr: {width: '60px'},
        formatter: yesOrNo
      },
      {
        key: 'holiday',
        label: 'Festivo',
        class: 'text-center',
        thStyle: {width: '60px'},
        tdAttr: {width: '60px'},
        formatter: yesOrNo
      },
      {key: 'comments', label: 'Observaciones'}
    ]
  },
  data() {
    return {
      fields: []
    }
  }
}

</script>

<style lang="css">

.table-wrapper-scroll-y {
  display: block;
  max-height: 200px;
  overflow-y: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

</style>



// WEBPACK FOOTER //
// src/components/projectOthersPartials/ProjectOthersPartialsTable.vue